import React, {useEffect} from 'react'
import {useFormContext} from "react-hook-form";
import {InputNumber} from "primereact/inputnumber";
import {labelSizeClass} from "./labelSize";

export default function UiInputNumber({ label, name, size, labelSize, asTable, ...rest }: any){
    const { register, setValue, watch } = useFormContext();
    const value = watch(name);

    useEffect(() => {
        register(name);
    }, [register]);

    return (
        <div className={`col-lg-${(size) ? size : 12}`}>
            <div className={`form-item${labelSizeClass(labelSize)}`}>
                { !asTable && <label className="form-label">{label}</label> }
                <div className="field-container">
                    <InputNumber
                        onChange={(e) => setValue(name, e.value)}
                        value={value}

                        allowEmpty={false}
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"

                        {...rest}
                    />
                </div>
            </div>
        </div>
    )
}